@if (workarea) {
    <div
        class="container-fluid"
        [class.readonly]="!([Functionalities.GeoManage, Functionalities.GeoRestricted] | hasFunctionality)">
        <div class="row">
            <div class="images-container">
                <h4>Afbeeldingen</h4>
                @if (loaded) {
                    <div class="scroll-container">
                        @for (image of workareaImages; track image.id; let i = $index) {
                            <figure class="pointer">
                                <div class="image-wrapper">
                                    <img
                                        src="{{ image.image_url }}?thumb=true"
                                        class="image"
                                        (click)="imageClick(image)" />
                                    <button class="image-delete-button" type="button" (click)="deleteImage(image)">
                                        <i class="fas fa-trash-alt" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <figcaption>
                                    <span class="fw-bold">{{ image?.status?.name }}</span>
                                    <br />
                                    @if (workarea.type === 'drillings') {
                                        {{ image.updated_at | date: 'd MMMM y' }}<br />
                                    } @else {
                                        {{ image.updated_at | date: "d MMMM y 'om' HH:mm" }}<br />
                                    }

                                    {{ image?.user?.name }}
                                </figcaption>
                            </figure>
                        }
                        <br /><br /><br /><br /><br /><br />
                    </div>
                }
                @if (Features.WorkareasPictureSave | hasFeature) {
                    @let isDisabled =
                        !loaded ||
                        !workarea.id ||
                        !workarea.status_id ||
                        ((Functionalities.GeoRestricted | hasFunctionality) &&
                            ([130, 131] | filter: workarea.status_id)?.length < 1);

                    @if (isNativePlatform) {
                        <button (click)="takePhoto()" [disabled]="isDisabled" color="primary" mat-raised-button>
                            <mat-icon class="icon-camera me-1"></mat-icon>
                            Foto
                            <span class="hidden-sm-down"> toevoegen</span>
                        </button>
                    } @else {
                        <button (click)="uploadInput.click()" [disabled]="isDisabled" color="primary" mat-raised-button>
                            <input #uploadInput (change)="uploadFile($event)" hidden multiple type="file" />
                            <mat-icon class="icon-camera me-1"></mat-icon>
                            Foto
                            <span class="hidden-sm-down"> toevoegen</span>
                        </button>
                    }
                }
            </div>
            <div class="scroll-container details-scroll-container">
                <div class="details-container">
                    <div class="row">
                        <div class="col-24">
                            <div class="detail-title">
                                <app-back-button backText="<b>{{ workarea.number }}</b> Gegevens"></app-back-button>
                            </div>
                            <div class="row">
                                <div class="col-24 col-md-18">
                                    @if (!loaded) {
                                        <app-processbar></app-processbar>
                                    }
                                </div>
                            </div>
                            <div class="row justify-content-between mt-1 px-3">
                                <div class="col-24">
                                    <div class="row justify-content-md-end action-buttons">
                                        <button mat-button (click)="openGoogleMaps()" class="col col-md-auto mb-2">
                                            <i class="fas fa-map-marked"></i> Google Maps
                                        </button>
                                        @if (appleMapsAvailable) {
                                            <button mat-button (click)="openAppleMaps()" class="col col-md-auto mb-2">
                                                <i class="fas fa-map-marked"></i> Apple Maps
                                            </button>
                                        }
                                        @if (flitsmeisterAvailable) {
                                            <button
                                                mat-button
                                                (click)="openFlitsmeister()"
                                                class="col col-md-auto mb-2">
                                                <i class="fa-solid fa-truck-fast"></i> Flitsmeister
                                            </button>
                                        }
                                        @if ((Functionalities.GeoManage | hasFunctionality) && !hasHoles()) {
                                            <button mat-button (click)="movingWorkarea()" class="col col-md-auto mb-2">
                                                <i class="fas fa-location-arrow"></i> Verplaatsen
                                            </button>
                                        }
                                        @if (Functionalities.GeoManage | hasFunctionality) {
                                            <button mat-button (click)="history()" class="col col-md-auto mb-2">
                                                <i class="fas fa-history"></i> Wijzigingen
                                            </button>
                                            <button mat-button (click)="pdf()" class="col col-md-auto mb-2">
                                                @if (generatingReport) {
                                                    <i class="fas fa-circle-notch fa-spin"></i>
                                                } @else {
                                                    <i class="fas fa-file-pdf"></i>
                                                }
                                                PDF
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            @if (loaded && fieldOptions && workarea) {
                                <form #workareaForm="ngForm">
                                    <app-workarea-naw
                                        (formValid)="isFromValid($event, 'naw')"
                                        [projects]="projects"
                                        [workarea]="workarea"></app-workarea-naw>
                                    @if (customerType === CustomerType.general) {
                                        <app-workarea-general
                                            (formValid)="isFromValid($event, 'general')"
                                            [fieldOptions]="fieldOptions"
                                            [statuses]="statuses"
                                            [workarea]="workarea">
                                        </app-workarea-general>
                                    }
                                    @if (customerType === CustomerType.straatwerk) {
                                        <app-workarea-straatwerk
                                            (formValid)="isFromValid($event, 'straatwerk')"
                                            [fieldOptions]="fieldOptions"
                                            [statuses]="statuses"
                                            [workarea]="workarea">
                                        </app-workarea-straatwerk>
                                    }
                                    @if (customerType === CustomerType.drillings) {
                                        <app-workarea-drill
                                            (formValid)="isFromValid($event, 'drillings')"
                                            [fieldOptions]="fieldOptions"
                                            [workarea]="workarea"></app-workarea-drill>
                                    }
                                    <div class="row mb-5 pb-5">
                                        <div
                                            [class.col-md-8]="workarea.type === 'drillings'"
                                            [class.col-md-12]="workarea.type !== 'drillings'"
                                            class="col-24">
                                            <div class="mb-3">
                                                <div
                                                    (click)="navigateBack()"
                                                    class="btn btn-outline-danger w-100 z-depth-0">
                                                    Terug naar kaart
                                                </div>
                                            </div>
                                        </div>
                                        @if (
                                            workarea.type === 'drillings' &&
                                            (Functionalities.GeoManage | hasFunctionality)
                                        ) {
                                            <div
                                                [class.col-md-8]="workarea.type === 'drillings'"
                                                [class.col-md-12]="workarea.type !== 'drillings'"
                                                class="col-24">
                                                <div class="mb-3">
                                                    <div
                                                        (click)="delete()"
                                                        class="btn btn-danger w-100 z-depth-0"
                                                        queryParamsHandling="merge">
                                                        Verwijderen
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        @if (Features.WorkareasSave | hasFeature) {
                                            <div
                                                [class.col-md-8]="workarea.type === 'drillings'"
                                                [class.col-md-12]="workarea.type !== 'drillings'"
                                                class="col-24">
                                                <div class="mb-3">
                                                    <button
                                                        (click)="save()"
                                                        [disabled]="
                                                            (Functionalities.GeoRestricted | hasFunctionality) &&
                                                            ([130, 131] | filter: workarea.status_id)?.length < 1
                                                        "
                                                        class="btn btn-success w-100 z-depth-0">
                                                        Opslaan
                                                    </button>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </form>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}
